import type { FC } from "react"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import fp from "lodash/fp"

import { useUpdateDeviceNameMutation } from "../../../features/api"
import EditableTitle from "../../common/editable/EditableTitle"
import ErrorPopUp from "../../common/ErrorPopUp"

interface IEditableDeviceNameProps {
  name: string
}

const EditableDeviceName: FC<IEditableDeviceNameProps> = ({ name }) => {
  const { id } = useParams()
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const [updateDeviceName, { isLoading, isSuccess, isError, error }] =
    useUpdateDeviceNameMutation()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const onSubmitHandler = (newName: string) => {
    updateDeviceName({
      less_id: Number(id),
      name: newName,
    })
  }

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    if (isError) {
      handleOpen()
      setErrorMessage(fp.get("data.message", error) || null)
    }
  }, [isError, error])

  return (
    <>
      <EditableTitle
        text={name}
        onSubmitHandler={onSubmitHandler}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <ErrorPopUp open={open} onClose={handleClose}>
        {errorMessage ? errorMessage : t("error.UPDATING_DEVICE_NAME")}
      </ErrorPopUp>
    </>
  )
}

export default EditableDeviceName
